<div
  class="attribution-switch"
  role="radiogroup"
  aria-label="Accrual or cash"
  [class.disabled]="!!disabledReason()"
  [matTooltip]="disabledReason() || '' | translate"
  [matTooltipDisabled]="!disabledReason()"
  matTooltipPosition="below">
  @for (option of options; track option.value) {
    <button
      type="button"
      role="radio"
      class="attribution-option"
      [class.active]="value() === option.value"
      [attr.aria-checked]="value() === option.value"
      [disabled]="!!disabledReason()"
      [matTooltip]="option.tooltip | translate"
      [matTooltipDisabled]="!!disabledReason()"
      matTooltipPosition="below"
      (click)="pick(option.value)">
      <tidy-text
        [headerButton]="option.shownLabel"
        [translate]="false"
        class="white" />
    </button>
  }
</div>
